'use client';
import React, { useEffect } from 'react';

import { ChatButton } from '@/slw/features/chat/chat-bubble.ui';
import { ChatDialog } from '@/slw/widgets/chat/chat-dialog.ui';
import { useAuthStore, useChatStore } from '@/slw/shared/stores';
import { markAllNotificationsAsRead, onMessageListener } from '@/slw/shared/lib/firebase/utils';
import { useNotifications } from '@/slw/features/chat/use-notifications';

export const ChatWidget = () => {
  const { isOpen, defaultLayout, toggleChat, closeChat, setDefaultLayout } = useChatStore();

  const { user: currentUser } = useAuthStore();

  const notification = useNotifications(currentUser?.id);

  useEffect(() => {
    const layoutCookie = localStorage.getItem('react-resizable-panels:collapsed');

    const unsubscribe = onMessageListener().then(() => {
      // Message received
    });

    if (layoutCookie) {
      setDefaultLayout(JSON.parse(layoutCookie));
    }

    return () => {
      unsubscribe.catch(() => {
        // Error handled
      });
    };
  }, [setDefaultLayout]);

  const handleOpenChat = async () => {
    if (currentUser?.id) {
      await markAllNotificationsAsRead(currentUser.id);
      toggleChat();
    }
  };

  return (
    <>
      <ChatButton onClick={handleOpenChat} isOpen={isOpen} count={notification?.count} />
      {<ChatDialog isOpen={isOpen} onClose={closeChat} defaultLayout={defaultLayout} navCollapsedSize={8} />}
    </>
  );
};
